import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'merz-cookies-section',
  templateUrl: './cookies-section.component.html',
  styleUrls: ['./cookies-section.component.scss']
})
export class CookiesSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
